module.exports = __webpack_public_path__ + "static/img/ding46.e144d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/ding46.png
// module id = 4I0N
// module chunks = 0